import {useEffect, useRef, useState} from "react";
import Video from "twilio-video";
import {VideoStatus} from "../../../enums/VideoStatus";

const RemoteParticipantView: React.FC<{
    participant: Video.RemoteParticipant,
    setVideoStatusProgress(status: VideoStatus): void,
}> = ({participant, setVideoStatusProgress,}) => {
    console.log("Remote Participant : ", participant)
    const [videoTracks, setVideoTracks] = useState<any>([]);
    const [audioTracks, setAudioTracks] = useState<any>([]);


    //const [loading, setLoading] = useState<string>("wait...");

    const videoRef: any = useRef();
    const audioRef: any = useRef();

    useEffect(() => {

    }, []);

    const trackPubsToTracks = (trackMap: any) =>
        Array.from(trackMap.values())
            .map((publication: any) => publication.track)
            .filter((track) => track !== null);

    useEffect(() => {
        setVideoTracks(trackPubsToTracks(participant.videoTracks));
        setAudioTracks(trackPubsToTracks(participant.audioTracks));

        const trackSubscribed = (track: any) => {
            if (track.kind === "video") {
                setVideoTracks((videoTracks: any) => [...videoTracks, track]);
            } else if (track.kind === "audio") {
                setAudioTracks((audioTracks: any) => [...audioTracks, track]);
            }
            setVideoStatusProgress(VideoStatus.ONLINE);
        };

        const trackUnsubscribed = (track: any) => {
            if (track.kind === "video") {
                setVideoTracks((videoTracks: any) => videoTracks.filter((v: any) => v !== track));
            } else if (track.kind === "audio") {
                setAudioTracks((audioTracks: any) => audioTracks.filter((a: any) => a !== track));
            }
            setVideoStatusProgress(VideoStatus.OFFLINE);
        };

        participant.on("trackSubscribed", trackSubscribed);
        participant.on("trackUnsubscribed", trackUnsubscribed);

        return () => {
            setVideoTracks([]);
            setAudioTracks([]);
            setVideoStatusProgress(VideoStatus.OFFLINE);
            participant.removeAllListeners();
        };
    }, [participant]);

    useEffect(() => {
        const videoTrack = videoTracks[0];
        if (videoTrack) {
            videoTrack.attach(videoRef.current);
            return () => {
                videoTrack.detach();
            };
        }
    }, [videoTracks]);

    useEffect(() => {
        const audioTrack = audioTracks[0];
        if (audioTrack) {
            audioTrack.attach(audioRef.current);

            return () => {
                audioTrack.detach();
            };
        }
    }, [audioTracks]);

    return (
        <div className="participant" style={{width: 280}}>
            {/*<h3>{participant.identity}</h3>*/}
            <video controls width={'100%'} ref={videoRef} autoPlay={true}  muted={true} playsInline={true}/>
            <audio ref={audioRef} autoPlay={true} muted={false}/>
        </div>
    );
};

export default RemoteParticipantView;
